// @ts-nocheck
import { fabric } from 'fabric';
import { ANNOTATION_TYPE, DEFAULT_FONT } from '../../../config';
import { mVToPx, pxToMv } from '../../../ui/helper';

let VerticalCaliper;

(function () {
  const STROKE = {
    strokeWidth: 2,
    selectable: false,
    hasBorders: false,
    stroke: 'red',
    originX: 'center',
    originY: 'center',
    hoverCursor: 'arrow',
  };

  VerticalCaliper = function (
    cv: any,
    points: any,
    offsetX: any,
    config: any,
    verticalChannelPlacement: any,
    channelIndex: any,
  ) {
    this.type = ANNOTATION_TYPE.VLINE;
    this.canvas = cv;
    this.channelIndex = channelIndex;
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.config = config;
    this.isVisible = true;

    this.y1 = points.y1;
    this.y2 = points.y2;
    this.x = points.x;
    this.isSelectedAt = null;
    this.spp = (config.samplingRate * config.wndDuration) / config.width;
    this.xr = offsetX + this.x * this.spp;
    this.yr1 = pxToMv(verticalChannelPlacement, config, this.y1, this.channelIndex);
    this.yr2 = pxToMv(verticalChannelPlacement, config, this.y2, this.channelIndex);
    this.convertConstant = (config.wndDuration * config.speed) / config.width / 10;

    this.colorVLine = 'blue';
  };

  VerticalCaliper.prototype.draw = function () {
    this.ls = new fabric.Line([this.x - 10, this.y1, this.x + 10, this.y1], STROKE);
    this.ls.id = 'ls';
    this.l = new fabric.Line([this.x, this.y1, this.x, this.y2], STROKE);
    this.l.id = 'l';
    this.le = new fabric.Line([this.x - 10, this.y2, this.x + 10, this.y2], STROKE);
    this.le.id = 'le';
    this.lt = new fabric.Text('0 mV', {
      left: this.x + 15,
      top: this.y,
      selectable: false,
      fontFamily: DEFAULT_FONT,
      fontSize: 14,
      fill: this.colorVLine,
      hoverCursor: 'arrow',
    });
    this.lt.id = 'lt';
    this.canvas.add(this.ls, this.l, this.le, this.lt);
  };

  VerticalCaliper.prototype.drawImport = function () {
    const STROKEIMPORT = {
      strokeWidth: 2,
      selectable: false,
      hasBorders: false,
      stroke: this.colorVLine,
      originX: 'center',
      originY: 'center',
      hoverCursor: 'arrow',
    };

    this.ls = new fabric.Line([this.x - 10, this.y1, this.x + 10, this.y1], STROKEIMPORT);
    this.ls.id = 'ls';
    this.l = new fabric.Line([this.x, this.y1, this.x, this.y2], STROKEIMPORT);
    this.l.id = 'l';
    this.le = new fabric.Line([this.x - 10, this.y2, this.x + 10, this.y2], STROKEIMPORT);
    this.le.id = 'le';
    this.lt = new fabric.Text('0 mV', {
      left: this.x + 15,
      top: this.y,
      selectable: false,
      fontFamily: DEFAULT_FONT,
      fontSize: 14,
      fill: this.colorVLine,
      hoverCursor: 'arrow',
    });
    this.lt.id = 'lt';
    this.canvas.add(this.ls, this.l, this.le, this.lt);
  };

  VerticalCaliper.prototype.render = function () {
    this.canvas.renderAll();
  };

  VerticalCaliper.prototype.update = function (
    delta: any,
    isDrawing: any,
    displayedChannelsArr: any,
  ) {
    if (this.isSelectedAt === 'le' || isDrawing) {
      this.y2 += delta.dy;
      for (let i = 0; i < displayedChannelsArr.length; i += 1) {
        if (this.channelIndex === displayedChannelsArr[i]) {
          this.yr2 = pxToMv(this.verticalChannelPlacement, this.config, this.y2, i);
        }
      }

      this.l.set({ y2: this.y2 });
      this.l.setCoords();
      this.le.set({ y1: this.y2, y2: this.y2 });
      this.le.setCoords();

      this.lt.set({
        // top: ((this.y1 + this.y2) / 2) - (this.lt.height / 2),

        // Cuong test
        text: `${(Math.abs(this.y1 - this.y2) / this.config.millivoltToPix).toFixed(3)} mV`,
        top: this.y1 - 20,
        left: this.x - this.lt.width / 2,
      });
      this.lt.setCoords();
    } else if (this.isSelectedAt === 'ls') {
      this.y1 += delta.dy;
      for (let i = 0; i < displayedChannelsArr.length; i += 1) {
        if (this.channelIndex === displayedChannelsArr[i]) {
          this.yr1 = pxToMv(this.verticalChannelPlacement, this.config, this.y1, i);
        }
      }

      this.l.set({ y1: this.y1 });
      this.l.setCoords();
      this.ls.set({ y1: this.y1, y2: this.y1 });
      this.le.setCoords();

      this.lt.set({
        // text: `${(Math.abs(this.y1 - this.y2) * this.convertConstant).toFixed(3)} mV`,
        // top: ((this.y1 + this.y2) / 2) - (this.lt.height / 2),

        // Cuong test
        text: `${(Math.abs(this.y1 - this.y2) / this.config.millivoltToPix).toFixed(3)} mV`,
        top: this.y1 - 20,
        left: this.x - this.lt.width / 2,
      });
      this.lt.setCoords();
    } else if (this.isSelectedAt === 'l') {
      this.l.set({
        x1: this.l.x1 + delta.dx,
        y1: this.l.y1 + delta.dy,
        x2: this.l.x2 + delta.dx,
        y2: this.l.y2 + delta.dy,
      });
      this.l.setCoords();

      this.lt.set({
        left: this.lt.left + delta.dx,
        top: this.lt.top + delta.dy,
      });
      this.lt.setCoords();

      this.ls.set({
        x1: this.ls.x1 + delta.dx,
        y1: this.ls.y1 + delta.dy,
        x2: this.ls.x2 + delta.dx,
        y2: this.ls.y2 + delta.dy,
      });
      this.ls.setCoords();

      this.le.set({
        x1: this.le.x1 + delta.dx,
        y1: this.le.y1 + delta.dy,
        x2: this.le.x2 + delta.dx,
        y2: this.le.y2 + delta.dy,
      });
      this.le.setCoords();

      this.y1 += delta.dy;
      this.y2 += delta.dy;
      this.x += delta.dx;
      this.xr += delta.dx * this.spp;
      for (let i = 0; i < displayedChannelsArr.length; i += 1) {
        if (this.channelIndex === displayedChannelsArr[i]) {
          this.yr1 = pxToMv(this.verticalChannelPlacement, this.config, this.y1, i);
          this.yr2 = pxToMv(this.verticalChannelPlacement, this.config, this.y2, i);
        }
      }
    }
  };

  VerticalCaliper.prototype.updateConfig = function (
    config: any,
    offsetX: any,
    verticalChannelPlacement: any,
    displayedChannelsArr: any,
  ) {
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.config = config;
    for (let i = 0; i < displayedChannelsArr.length; i += 1) {
      if (this.channelIndex === displayedChannelsArr[i]) {
        const prevValue = Math.abs(this.y2 - this.y1);
        this.spp = (config.samplingRate * config.wndDuration) / config.width;

        this.y1 = mVToPx(verticalChannelPlacement, config, this.yr1, i);
        this.y2 = mVToPx(verticalChannelPlacement, config, this.yr2, i);
        this.x = (this.xr - offsetX) / this.spp;
        const currentValue = Math.abs(this.y2 - this.y1);
        this.convertConstant = prevValue
          ? this.convertConstant / (currentValue / prevValue)
          : this.convertConstant;

        this.ls.set({
          x1: this.x - 10,
          x2: this.x + 10,
          y1: this.y1,
          y2: this.y1,
        });
        this.ls.setCoords();
        this.l.set({
          x1: this.x,
          x2: this.x,
          y1: this.y1,
          y2: this.y2,
        });
        this.l.setCoords();
        this.le.set({
          x1: this.x - 10,
          x2: this.x + 10,
          y1: this.y2,
          y2: this.y2,
        });
        this.le.setCoords();
        this.lt.set({
          fontSize: 14,
          text: `${(Math.abs(this.y1 - this.y2) * this.convertConstant).toFixed(3)} mV`,
          top: this.y1 - 20,
        });
        this.lt.set({ left: this.x - this.lt.width / 2 });
        this.lt.setCoords();
        this.isVisibility(true);

        break;
      } else {
        this.isVisibility(false);
      }
    }
  };

  VerticalCaliper.prototype.updateChannelIdx = function (
    channelIndex: any,
    displayedChannelsArr: any,
  ) {
    this.channelIndex = channelIndex;
    for (let i = 0; i < displayedChannelsArr.length; i += 1) {
      if (this.channelIndex === displayedChannelsArr[i]) {
        this.yr1 = pxToMv(this.verticalChannelPlacement, this.config, this.y1, i);
        this.yr2 = pxToMv(this.verticalChannelPlacement, this.config, this.y2, i);
        break;
      }
    }
  };

  VerticalCaliper.prototype.changeColor = function (color: any) {
    this.colorVLine = color;

    // Change color after choose menu option
    this.ls.set({ stroke: this.colorVLine });
    this.l.set({ stroke: this.colorVLine });
    this.le.set({ stroke: this.colorVLine });
    this.lt.set({ fill: this.colorVLine });
  };

  VerticalCaliper.prototype.scroll = function (offsetX: any, displayedChannelsArr: any) {
    for (let i = 0; i < displayedChannelsArr.length; i += 1) {
      if (this.channelIndex === displayedChannelsArr[i]) {
        this.x = (this.xr - offsetX) / this.spp;

        this.ls.set({ x1: this.x - 10, x2: this.x + 10 });
        this.ls.setCoords();
        this.l.set({ x1: this.x, x2: this.x });
        this.l.setCoords();
        this.le.set({ x1: this.x - 10, x2: this.x + 10 });
        this.le.setCoords();
        this.lt.set({
          // left: this.x + 15,

          // Cuong test
          top: this.y1 - 20,
          left: this.x - this.lt.width / 2,
        });
        this.lt.setCoords();

        if (this.x < 0 || this.x > 945) {
          this.isVisibility(false);
        } else {
          this.isVisibility(true);
        }
        break;
      }
    }
  };

  VerticalCaliper.prototype.isSelected = function (pointer: any) {
    if (this.y1 <= this.y2) {
      if (
        pointer.y > this.y1 + 5 &&
        pointer.y < this.y2 - 5 &&
        pointer.x > this.x - 5 &&
        pointer.x < this.x + 5
      ) {
        this.isSelectedAt = 'l';
      } else if (
        pointer.y > this.y1 - 5 &&
        pointer.y < this.y1 + 5 &&
        pointer.x > this.x - 10 &&
        pointer.x < this.x + 10
      ) {
        this.isSelectedAt = 'ls';
      } else if (
        pointer.y > this.y2 - 5 &&
        pointer.y < this.y2 + 5 &&
        pointer.x > this.x - 10 &&
        pointer.x < this.x + 10
      ) {
        this.isSelectedAt = 'le';
      } else {
        this.isSelectedAt = null;
      }
    } else if (this.y1 > this.y2) {
      if (
        pointer.y > this.y2 + 5 &&
        pointer.y < this.y1 - 5 &&
        pointer.x > this.x - 5 &&
        pointer.x < this.x + 5
      ) {
        this.isSelectedAt = 'l';
      } else if (
        pointer.y > this.y2 - 5 &&
        pointer.y < this.y2 + 5 &&
        pointer.x > this.x - 10 &&
        pointer.x < this.x + 10
      ) {
        this.isSelectedAt = 'le';
      } else if (
        pointer.y > this.y1 - 5 &&
        pointer.y < this.y1 + 5 &&
        pointer.x > this.x - 10 &&
        pointer.x < this.x + 10
      ) {
        this.isSelectedAt = 'ls';
      } else {
        this.isSelectedAt = null;
      }
    }

    if (this.isSelectedAt) {
      return true;
    }
    return false;
  };

  VerticalCaliper.prototype.select = function () {
    this.ls.set({ stroke: 'red' });
    this.l.set({ stroke: 'red' });
    this.le.set({ stroke: 'red' });
    this.lt.set({ fill: 'red' });
  };

  VerticalCaliper.prototype.deselect = function () {
    this.ls.set({ stroke: this.colorVLine });
    this.l.set({ stroke: this.colorVLine });
    this.le.set({ stroke: this.colorVLine });
    this.lt.set({ fill: this.colorVLine });
  };

  VerticalCaliper.prototype.isVisibility = function (isVisibility: any) {
    this.isVisible = isVisibility;
    this.ls.visible = isVisibility;
    this.l.visible = isVisibility;
    this.le.visible = isVisibility;
    this.lt.visible = isVisibility;
  };

  VerticalCaliper.prototype.getJSONObject = function () {
    return {
      type: this.type,
      channelIndex: this.channelIndex,
      xr: this.xr,
      yr1: this.yr1,
      yr2: this.yr2,
      colorVLine: this.colorVLine,
    };
  };

  VerticalCaliper.prototype.import = function (data: any) {
    this.channelIndex = data.channelIndex;
    this.xr = data.xr;
    this.yr1 = data.yr1;
    this.yr2 = data.yr2;
    this.colorVLine = data.colorVLine;

    this.x = this.xr / this.spp;
    this.y1 = mVToPx(this.verticalChannelPlacement, this.config, this.yr1, this.channelIndex);
    this.y2 = mVToPx(this.verticalChannelPlacement, this.config, this.yr2, this.channelIndex);

    // this.draw();
    this.drawImport();
    this.lt.set({
      text: `${(Math.abs(this.y1 - this.y2) * this.convertConstant).toFixed(3)} mV`,
    });
    this.lt.set({
      top: (this.y1 + this.y2) / 2 - this.lt.height / 2,
    });
    this.lt.setCoords();
  };
})();

export { VerticalCaliper };
export default { VerticalCaliper };
